import { render, staticRenderFns } from "./SubAgents.vue?vue&type=template&id=6d6d71a6&scoped=true&"
import script from "./SubAgents.vue?vue&type=script&lang=js&"
export * from "./SubAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d71a6",
  null
  
)

export default component.exports